import axios from 'axios'
import library from '../../../utils/Library'

export const helpUpdateUserofOrganizationLoginAccount = async (user) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = library.getBaseAPIUrl('login_account') + '/loginAccountUpdate'

  return await axios({
    url: URL,
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: user
  })
}
